// Starts the download of the page's text faces as soon as main.js runs, instead of when the lazy route chunk first
// paints text, so the swap from their measured fallbacks (design/tokens.css, which main.css carries) lands before
// that first paint and does not rewrap the page on screen. Only the faces the page uses, so they do not compete with
// the route chunk for bandwidth: Schibsted Grotesk on every Director host (the public pages since the 2026-10-31
// rebrand, round 1, and the wordmark everywhere), plus Onest where the tools are (the Panel on app.*, Web Studio
// under /web), and nothing on Vynko (its own face, Archivo). On the public pages the build also preloads the core
// file of the brand face in the <head> (scripts/inject-font-preload.js). Nothing waits on them: a slow or failed load
// still falls back as before. One variable file per face covers every weight, so one load each is enough.

export const BRAND_FONT = '400 1em "Schibsted Grotesk"';
export const TOOL_FONT = '400 1em "Onest"';

export function facesFor(loc) {
  const host = (loc && loc.hostname) || "";
  const path = (loc && loc.pathname) || "";
  if (/(^|\.)getvynko\./.test(host)) return [];
  const tools = /^app\./.test(host) || path === "/web" || path.startsWith("/web/");
  return tools ? [BRAND_FONT, TOOL_FONT] : [BRAND_FONT];
}

export function warmFonts(doc) {
  const fonts = doc && doc.fonts;
  if (!fonts || typeof fonts.load !== "function") return Promise.resolve(undefined);
  const faces = facesFor(doc.location || (typeof window !== "undefined" ? window.location : null));
  return Promise.all(faces.map((f) => Promise.resolve(fonts.load(f)).catch(() => undefined))).then(() => undefined);
}
